module.exports = __webpack_public_path__ + "img/list-delete-button.78eaa996.svg";